import { AIButtonContainedDark } from './AIButtonContainedDark'
import { AIButtonContainedGrey } from './AIButtonContainedGrey'
import { AIButtonContainedLight } from './AIButtonContainedLight'
import { AIButtonIcon } from './AIButtonIcon'
import { AIButtonIconFlat } from './AIButtonIconFlat'
import { AIButtonIconGrey } from './AIButtonIconGrey'
import { AIButtonOutlined } from './AIButtonOutlined'
import { AIButtonText } from './AIButtonText'
import { AIButtonTextGrey } from './AIButtonTextGrey'

export const AI_BUTTON_MENU = [
  'AIButton',
  [
    ['ContainedDark', AIButtonContainedDark],
    ['ContainedLight', AIButtonContainedLight],
    ['ContainedGrey', AIButtonContainedGrey],
    ['Outlined', AIButtonOutlined],
    ['Text', AIButtonText],
    ['TextGrey', AIButtonTextGrey],
    ['Icon', AIButtonIcon],
    ['IconGrey', AIButtonIconGrey],
    ['IconFlat', AIButtonIconFlat],
  ],
]
